module.exports = __webpack_public_path__ + "img/loading.6525f20e.gif";